import ElInput from './src/input';

/* istanbul ignore next */
ElInput.install = function(Vue) {
  Vue.component(ElInput.name, ElInput);
};

export default ElInput;



// WEBPACK FOOTER //
// ./node_modules/_element-ui@2.15.1@element-ui/packages/input/index.js